<template>
  <div v-if="prescriptions.length" class="flex flex-col gap-5">
    <PrescriptionCard
      v-for="prescription in prescriptions"
      :key="prescription.key"
      :prescription="prescription"
    />
  </div>
  <div
    v-else
    class="p-8"
  >
    {{ noPrescriptionMessage }}
  </div>
</template>

<script setup lang="ts">
import {Prescription} from "@/prescription/interfaces/Prescription";
import PrescriptionCard from "@/prescription/components/PrescriptionCard.vue";

withDefaults(
    defineProps<{prescriptions: Prescription[], noPrescriptionMessage?: string}>(),
    {noPrescriptionMessage: 'Aucune ordonnance disponible'}
);
</script>
